import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../../../modules/shared/services/local-data.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "resource-asset-display-config",
    templateUrl: "./resource-asset-display-config.html",
    providers: []
})
export class ResourceAssetDisplayConfigView implements OnInit {
    assetList: Array<any> = [];
    baseUrl = "";
    assetSetUp: any = {};

    constructor(
        public sharedService: SharedService,
        private localDataService: LocalDataService,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = this.sharedService.sessionUrl;
            if(!this.sharedService.sessionLayoutConfig[this.baseUrl].hasOwnProperty('assetConfig')) {
                this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.assetSetUp = this.sharedService.assetConfig.assetSetUp;
            }
            
            this.assetSetUp = this.sharedService.sessionLayoutConfig[this.baseUrl].assetConfig.assetSetUp;
            
        }
    }
}
